import { render } from "./BaseSelect.vue?vue&type=template&id=ce2c65d4&scoped=true&ts=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"

import "./BaseSelect.vue?vue&type=style&index=0&id=ce2c65d4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2c65d4"]])

export default __exports__